import Vue from "vue";
import { DatetimePicker, Uploader } from "vant";

Vue.use(DatetimePicker);
Vue.use(Uploader);
